import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faXTwitter, faLinkedinIn } from '@fortawesome/free-brands-svg-icons'
import anmaticsLogo from '../images/new/logo-ui.png';
// import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
const Footer = () => {
    return (
        <footer id="footer" className="footer-section footer-lean py-5">
            <div className="container" data-aos="fade-up">
                <div className="row g-4 align-items-start">
                    <div className="col-lg-5">
                        <div className="footer-brand d-flex align-items-center mb-3">
                            <img
                                src={anmaticsLogo}
                                alt="Anmatics logo"
                                className="footer-logo"
                                width="42"
                                height="42"
                                loading="lazy"
                                decoding="async"
                            />
                            <span className="brand-text footer-brand-text">Anmatics</span>
                            <sup className="brand-reg footer-brand-reg">®</sup>
                        </div>
                        <p className="text-white mb-4">
                            Engineering reliable web, mobile, SaaS, and AI-ready systems for companies that need
                            structured delivery and long-term scalability.
                        </p>
                        <a href="/#contact" className="footer-contact-link">Book a technical consultation</a>
                    </div>

                    <div className="col-lg-3 col-md-6">
                        <h5 className="fw-bold text-white mb-3">Company</h5>
                        <ul className="footer-links list-unstyled">
                            <li><a href="/#home">Home</a></li>
                            <li><a href="/#about">About</a></li>
                            <li><a href="/#services">Services</a></li>
                            <li><a href="/#faq">FAQ</a></li>
                            <li><a href="/#product">Product</a></li>
                        </ul>
                    </div>

                    <div className="col-lg-2 col-md-6">
                        <h5 className="fw-bold text-white mb-3">Explore</h5>
                        <ul className="footer-links list-unstyled">
                            <li><a href="/blogs">Insights</a></li>
                            <li><a href="/product-details">DecklePro</a></li>
                            <li><a href="/#contact">Contact</a></li>
                        </ul>
                    </div>

                    <div className="col-lg-2 col-md-6">
                        <h5 className="fw-bold text-white mb-3">Social</h5>
                        <div className="social-icons d-flex gap-3">
                            <a href="https://www.facebook.com/share/16xFv6aVpA/?mibextid=wwXIfr" className="social-icon">
                                <FontAwesomeIcon icon={faFacebookF} />
                            </a>
                            <a href="https://x.com/anmatics-technologies/" className="social-icon">
                                <FontAwesomeIcon icon={faXTwitter} />
                            </a>
                            <a href="https://www.linkedin.com/company/anmatics-technologies/" className="social-icon">
                                <FontAwesomeIcon icon={faLinkedinIn} />
                            </a>
                        </div>
                    </div>
                </div>

                <div className="footer-bottom mt-5 pt-4 border-top border-light-subtle">
                    <p className="text-white mb-0">
                        &copy; {new Date().getFullYear()} Anmatics<sup>®</sup> Technologies. All Rights Reserved.
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
